import "@/js/lib/jquery.form-submit-single";
import $ from "jquery";

export const formSubmitSingle = () => {
    $("body").on("submit.formSubmitSingle", "form[method=post]", $.onFormSubmitSingle);
};
